export default "__VITE_ASSET__BdfFdKUX__"